var _rect, _rect2, _g, _rect3, _g2, _path, _g3, _g4, _rect4, _path2, _path3, _path4, _g5, _g6, _g7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceivedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.7959,
    y: 65.3823,
    width: 65.3403,
    height: 46.4921,
    fill: "#474B56"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_9287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 41,
    width: 47,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.01,
    y: 41.9268,
    width: 46.911,
    height: 23.4555,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.465 88.8378C134.419 88.8378 144.921 78.3365 144.921 65.3823C144.921 52.4282 134.419 41.9268 121.465 41.9268C108.511 41.9268 98.0098 52.4282 98.0098 65.3823C98.0098 78.3365 108.511 88.8378 121.465 88.8378ZM121.465 82.974C131.181 82.974 139.057 75.0979 139.057 65.3823C139.057 55.6668 131.181 47.7907 121.465 47.7907C111.75 47.7907 103.874 55.6668 103.874 65.3823C103.874 75.0979 111.75 82.974 121.465 82.974Z",
    fill: "#EDD26B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.466,
    cy: 65.3823,
    r: 17.5916,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.465,
    cy: 65.3823,
    r: 15.0785,
    fill: "#EDD26B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_85_9287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 65,
    width: 47,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.01,
    y: 65.3822,
    width: 46.911,
    height: 23.4555,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.465 88.8378C134.419 88.8378 144.921 78.3364 144.921 65.3823C144.921 52.4281 134.419 41.9268 121.465 41.9268C108.511 41.9268 98.0098 52.4281 98.0098 65.3823C98.0098 78.3364 108.511 88.8378 121.465 88.8378ZM121.465 82.9739C131.181 82.9739 139.057 75.0978 139.057 65.3823C139.057 55.6667 131.181 47.7906 121.465 47.7906C111.75 47.7906 103.874 55.6667 103.874 65.3823C103.874 75.0978 111.75 82.9739 121.465 82.9739Z",
    fill: "#5988FA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.466,
    cy: 65.3822,
    r: 17.5916,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.465,
    cy: 65.3822,
    r: 15.0785,
    fill: "#5988FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.578 111.506C121.068 111.997 121.864 111.997 122.355 111.506L130.351 103.51C130.842 103.019 130.842 102.223 130.351 101.733C129.86 101.242 129.065 101.242 128.574 101.733L121.466 108.841L114.358 101.733C113.867 101.242 113.072 101.242 112.581 101.733C112.09 102.223 112.09 103.019 112.581 103.51L120.578 111.506ZM120.21 65.3823L120.21 110.618L122.723 110.618L122.723 65.3823L120.21 65.3823Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6014 72.0837C35.6014 79.2546 29.7883 85.0678 22.6174 85.068C29.7883 85.0681 35.6014 90.8813 35.6014 98.0523C35.6014 98.0523 35.6014 98.0523 35.6014 98.0523C35.6014 98.0523 35.6014 98.0523 35.6014 98.0523C35.6014 90.8812 41.4147 85.068 48.5857 85.068M48.5857 85.068C41.4147 85.068 35.6015 79.2547 35.6014 72.0837L48.5857 85.068Z",
    fill: "#4CD7F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2883 51.9793C55.2883 55.4491 52.4755 58.262 49.0056 58.262C52.4755 58.262 55.2883 61.0749 55.2883 64.5447C55.2883 61.0749 58.1012 58.262 61.5711 58.262C58.1012 58.262 55.2883 55.4491 55.2883 51.9793Z",
    fill: "#3DC188"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.8458,
    y: 33.8122,
    width: 65.3403,
    height: 12.1466,
    transform: "rotate(-15 74.8458 33.8122)",
    fill: "#474B56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.142 37.1976L105.998 25.4649",
    stroke: "white",
    strokeWidth: 1.25654
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.998 25.465L106.098 26.0854C106.397 26.0374 106.619 25.7828 106.626 25.4799C106.634 25.177 106.423 24.9121 106.127 24.8501L105.998 25.465ZM105.998 25.465C105.899 24.8447 105.899 24.8447 105.899 24.8447C105.899 24.8447 105.898 24.8447 105.898 24.8448C105.898 24.8448 105.897 24.8449 105.896 24.8451C105.895 24.8453 105.892 24.8458 105.888 24.8463C105.882 24.8474 105.871 24.8491 105.858 24.8512C105.831 24.8556 105.79 24.862 105.737 24.8705C105.631 24.8874 105.475 24.9123 105.274 24.9441C104.873 25.0077 104.293 25.0991 103.583 25.2101C102.161 25.4322 100.212 25.7328 98.1052 26.0469C93.8832 26.6763 89.0529 27.3559 86.5412 27.5705L86.6482 28.8224C89.2068 28.6038 94.0782 27.9177 98.2905 27.2897C100.401 26.9751 102.352 26.674 103.776 26.4516C104.488 26.3404 105.069 26.2489 105.471 26.1851C105.672 26.1533 105.829 26.1283 105.935 26.1114C105.988 26.1029 106.029 26.0964 106.056 26.092C106.07 26.0898 106.08 26.0882 106.087 26.087C106.091 26.0865 106.093 26.0861 106.095 26.0858C106.096 26.0856 106.097 26.0855 106.097 26.0855C106.097 26.0854 106.097 26.0854 106.098 26.0854C106.098 26.0854 106.098 26.0854 105.998 25.465ZM86.5412 27.5705C85.4509 27.6636 84.742 27.3133 84.2986 26.811C83.837 26.2882 83.6043 25.5325 83.6239 24.7421C83.6435 23.9503 83.9148 23.2004 84.3622 22.7031C84.7892 22.2284 85.3943 21.9576 86.212 22.1021L86.4307 20.8647C85.1673 20.6415 84.1322 21.08 83.428 21.8627C82.7441 22.6229 82.3933 23.6785 82.3677 24.711C82.3421 25.745 82.6413 26.8324 83.3566 27.6427C84.0901 28.4734 85.2033 28.9459 86.6482 28.8224L86.5412 27.5705ZM86.212 22.1021C88.2825 22.468 93.1918 23.4613 97.5942 24.3655C99.7931 24.8171 101.862 25.2457 103.381 25.5614C104.141 25.7193 104.763 25.849 105.195 25.9391C105.411 25.9842 105.58 26.0194 105.695 26.0434C105.752 26.0553 105.796 26.0645 105.825 26.0707C105.84 26.0737 105.851 26.0761 105.858 26.0776C105.862 26.0784 105.865 26.079 105.867 26.0794C105.868 26.0796 105.868 26.0797 105.869 26.0798C105.869 26.0799 105.869 26.0799 105.869 26.0799C105.87 26.08 105.87 26.08 105.998 25.465C106.127 24.8501 106.127 24.85 106.127 24.85C106.127 24.85 106.126 24.85 106.126 24.8499C106.126 24.8498 106.125 24.8497 106.124 24.8495C106.122 24.8491 106.119 24.8485 106.116 24.8477C106.108 24.8461 106.097 24.8438 106.082 24.8407C106.053 24.8345 106.009 24.8254 105.951 24.8134C105.837 24.7894 105.668 24.7542 105.452 24.7091C105.019 24.6188 104.397 24.4891 103.637 24.3312C102.117 24.0153 100.047 23.5865 97.847 23.1346C93.4516 22.2319 88.5224 21.2344 86.4307 20.8647L86.212 22.1021Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.998 25.4649L106.222 26.0519C105.939 26.1599 105.619 26.0506 105.462 25.7918C105.304 25.5331 105.353 25.1987 105.579 24.9967L105.998 25.4649ZM105.998 25.4649C105.774 24.8779 105.774 24.8779 105.774 24.8779C105.774 24.8779 105.774 24.8778 105.775 24.8777C105.775 24.8776 105.776 24.8773 105.776 24.877C105.778 24.8764 105.78 24.8755 105.784 24.8742C105.79 24.8717 105.8 24.868 105.813 24.8631C105.839 24.8533 105.877 24.8387 105.927 24.8195C106.027 24.7811 106.175 24.7245 106.365 24.6517C106.744 24.5061 107.291 24.2956 107.963 24.0363C109.305 23.5176 111.143 22.8037 113.125 22.0223C117.096 20.4564 121.619 18.6298 123.901 17.5598L124.434 18.6975C122.109 19.7875 117.547 21.629 113.586 23.1912C111.601 23.974 109.76 24.689 108.416 25.2084C107.743 25.4681 107.195 25.6789 106.815 25.8248C106.625 25.8978 106.477 25.9545 106.376 25.993C106.326 26.0123 106.287 26.027 106.261 26.0369C106.248 26.0418 106.239 26.0456 106.232 26.0481C106.229 26.0493 106.226 26.0503 106.225 26.0509C106.224 26.0512 106.223 26.0515 106.223 26.0516C106.223 26.0517 106.222 26.0518 106.222 26.0518C106.222 26.0519 106.222 26.0519 105.998 25.4649ZM123.901 17.5598C124.892 17.0953 125.331 16.4375 125.464 15.7808C125.602 15.0972 125.426 14.3264 125.013 13.6517C124.6 12.9757 123.991 12.462 123.355 12.255C122.747 12.0574 122.088 12.1254 121.452 12.6594L120.644 11.6972C121.626 10.8721 122.742 10.7343 123.743 11.0601C124.716 11.3765 125.547 12.1153 126.086 12.9966C126.625 13.8793 126.91 14.9707 126.695 16.03C126.475 17.1162 125.747 18.082 124.434 18.6975L123.901 17.5598ZM121.452 12.6594C119.842 14.0116 116.087 17.3264 112.726 20.3107C111.048 21.8012 109.471 23.2069 108.313 24.2399C107.734 24.7564 107.26 25.1798 106.931 25.474C106.766 25.6211 106.638 25.7359 106.55 25.8139C106.507 25.8529 106.473 25.8827 106.451 25.9028C106.44 25.9128 106.431 25.9204 106.425 25.9255C106.423 25.928 106.421 25.93 106.419 25.9312C106.418 25.9319 106.418 25.9324 106.417 25.9327C106.417 25.9328 106.417 25.933 106.417 25.933C106.417 25.9331 106.417 25.9332 105.998 25.4649C105.579 24.9967 105.579 24.9966 105.579 24.9966C105.579 24.9965 105.58 24.9964 105.58 24.9962C105.58 24.9959 105.581 24.9954 105.581 24.9947C105.583 24.9935 105.585 24.9915 105.588 24.989C105.593 24.9839 105.602 24.9763 105.613 24.9662C105.636 24.9461 105.669 24.9163 105.713 24.8772C105.8 24.7991 105.929 24.6842 106.093 24.537C106.423 24.2426 106.897 23.8191 107.476 23.3023C108.634 22.2688 110.213 20.8625 111.892 19.3711C115.247 16.3916 119.017 13.0631 120.644 11.6972L121.452 12.6594Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.549 51.5249C200.543 51.5246 207.024 45.0442 207.024 37.0501H207.024C207.024 45.0445 213.505 51.5251 221.499 51.5251C221.499 51.5251 221.499 51.5251 221.499 51.5251V51.5254C221.499 51.5254 221.499 51.5254 221.499 51.5254C213.505 51.5254 207.024 58.006 207.024 66.0002H207.024C207.024 58.0061 200.543 51.5256 192.549 51.5254V51.5249Z",
    fill: "#46C08D"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.499 27.5251C178.75 27.5247 183.008 23.2754 183.023 18.028C183.038 23.2757 187.297 27.5251 192.548 27.5251C192.549 27.5251 192.549 27.5251 192.549 27.5251V27.5253C192.549 27.5253 192.549 27.5253 192.548 27.5253C187.297 27.5253 183.038 31.7748 183.023 37.0225C183.008 31.775 178.75 27.5257 173.499 27.5253V27.5251Z",
    fill: "#45DAFA"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_85_9287)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.512 84.2705C177.3 84.27 180.37 81.1992 180.37 77.4111H180.37C180.371 81.1995 183.442 84.2705 187.23 84.2705C187.23 84.2705 187.231 84.2705 187.231 84.2705V84.2708C187.231 84.2708 187.23 84.2708 187.23 84.2708C183.442 84.2708 180.37 87.342 180.37 91.1305C180.37 91.1305 180.37 91.1306 180.37 91.1306H180.37C180.37 91.1306 180.37 91.1305 180.37 91.1305C180.37 87.3423 177.3 84.2713 173.512 84.2708V84.2705Z",
    fill: "#F4D86D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9686,
    height: 25.9686,
    fill: "white",
    transform: "translate(22.6182 72.0835)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_85_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5654,
    height: 12.5654,
    fill: "white",
    transform: "translate(49.0049 51.979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_85_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.9501,
    height: 28.9501,
    fill: "white",
    transform: "translate(192.55 37.0503)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_85_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0502,
    height: 19.0502,
    fill: "white",
    transform: "translate(173.5 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_85_9287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7194,
    height: 13.7194,
    fill: "white",
    transform: "translate(173.512 77.4111)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedIcon);
export default __webpack_public_path__ + "static/media/received-icon.6d6ca38488ddd0e93dae7c68d004afe4.svg";
export { ForwardRef as ReactComponent };